import styled, { css, keyframes } from 'styled-components';

const blueSolid = `rgba(17, 83, 228, 1)`;
const blueTransparent = `rgba(17, 83, 228, 0.9)`;
const redSolid = `rgba(235, 0, 55, 1)`;
const redTransparent = `rgba(235, 0, 55, 0.9)`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledSaber = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledBladeContainer = styled.div`
  position: relative;
  width: 544px;
  height: 14px;
  margin-left: -1px;
  background: #1153e4;
  border-radius: 0 0.7rem 0.7rem 0;
`;

const dull = (col: string) => css`
  box-shadow: inset 0px 0px 5px 4px ${col};
`;

const bright = (col: string, colTransparent: string) => css`
  box-shadow: inset 0px 0px 3px 2px ${col}, 0px 0px 44px 22px ${colTransparent};
`;

const glow = (col: string, colTransparent: string) => keyframes`
  0% { ${dull(col)} }
  30% { ${bright(col, colTransparent)} }
  70% { ${bright(col, colTransparent)} }
  100% { ${dull(col)} }
`;

export const StyledBlade = styled.div<{ red?: boolean; delay: number }>`
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fafafa;
  border-radius: 0.7rem;
  box-shadow: inset 0px 0px 5px 4px #1153e4;
  animation: ${({ red }) => (red ? glow(redSolid, redTransparent) : glow(blueSolid, blueTransparent))} 4s ease-out
    infinite;
  animation-delay: ${({ delay }) => `${delay}ms`};
`;
